/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LargeFeedFilter } from "cms/shared/feeds/large";
import { FeedbackForm } from "components/feedback-form";

const Licences = () => {


    const type = "model.licence";

    return (
        <main>
            <h1 style={{ marginTop: "16px" }}>
                Licences
            </h1>

            <LargeFeedFilter
                type={type}
            />

            <FeedbackForm />

        </main>
    );
};

export { Licences };
